<template>
    <div class="rkld">
        <div class="rkldRight">
            <div class="rkldRightContent">
                <!-- tabs导航 -->
                <el-tabs v-model="editableTabsValue" type="card">
                    <el-tab-pane label="走访探视类型设置" name="1">
                        <!--搜索框-->
                        <div class="searchTj">
                            <div class="searchTjHead">
                                <span>查询条件</span>
                                <!-- <el-button
                                    style="
                                        float: right;
                                        padding: 3px 0;
                                        color: #000;
                                    "
                                    type="text"
                                    @click.native="Resert"
                                >
                                    <i class="el-icon-refresh"></i>
                                    刷新页面
                                </el-button> -->
                                <i class="searchDomw" @click="searchValue = !searchValue" :class="searchValue==true?'el-icon-arrow-up':'el-icon-arrow-down'"></i>
                            </div>
                            <el-form :model="form" class="searchTjContent" v-show="searchValue">
                                <div
                                    class="searchTjContentDiv"
                                   
                                >
                                    <span class="searchTjContentDivSpan"
                                        >服务类型名称</span
                                    >
                                    <el-select
                                        v-model="form.typeName"
                                        placeholder="请选择服务类型"
                                    >
                                        <el-option label='上门走访、探望' value='上门走访、探望'></el-option>
                                        <el-option label='信息服务' value='信息服务'></el-option>
                                    </el-select>
                                </div>
                                <div
                                    class="searchTjContentDiv"
                                    v-show="searchValue"
                                >
                                    <el-button
                                        type="primary"
                                        class="searchBtns"
                                        @click="query"
                                        >查询</el-button
                                    >
                                </div>
                                <div
                                    class="searchTjContentDiv"
                                    v-show="searchValue"
                                >
                                    <el-button
                                        type="info"
                                        class="resetReach"
                                        @click="resert"
                                        >重置</el-button
                                    >
                                </div>
                                <!-- <div
                                    class="arrowDown"
                                    @click="showSearch"
                                    style="color: #000"
                                >
                                    <i class="el-icon-arrow-down"></i>
                                </div> -->
                            </el-form>
                        </div>
                        <div class="searchButtonDiv" v-show="quanbu">
                            <div class="searchButtonDivLeft">
                                <el-button-group>
                                    <el-button
                                        icon="el-icon-plus"
            class="openBtns"
                                        type="success"
                                        @click="handleClick('新增')"
                                        >新增</el-button
                                    >
                                    <el-button
                                        icon="el-icon-close"
                                        type="danger"
                                        @click="batchDelete"
                                        >批量删除</el-button
                                    >
                                </el-button-group>
                            </div>
                            <!-- 筛选按钮 -->
                            <div class="searchButtonDiveRight">
                                <el-button-group>
                                    <el-button
                                        type="primary"
                                        icon="el-icon-refresh"
                                        class="dropRests"
                                        @click="resertTable"
                                    ></el-button>
                                    <!-- <el-button type="primary"> -->
                                    <el-dropdown
                                        class="dropdown"
                                        trigger="click"
                                        :hide-on-click="false"
                                    >
                                        <span class="el-dropdown-link">
                                            <i
                                                class="el-icon-s-grid el-icon--right"
                                                style="color: #fff"
                                            ></i>
                                            <i
                                                class="el-icon-arrow-down el-icon--right"
                                            ></i>
                                        </span>
                                        <el-dropdown-menu slot="dropdown">
                                            <el-dropdown-item>
                                                <template>
                                                    <el-checkbox-group
                                                        v-model="checkList"
                                                        :min="1"
                                                        @change="tableShow"
                                                    >
                                                        <el-checkbox
                                                            label="序号"
                                                            >序号</el-checkbox
                                                        ><br />
                                                         <el-checkbox
                                                            label="项目名称"
                                                            >服务类型名称</el-checkbox
                                                        ><br />
                                                        <el-checkbox
                                                            label="服务类型名称"
                                                            >服务类型名称</el-checkbox
                                                        ><br />
                                                        <el-checkbox
                                                            label="创建时间"
                                                            >创建时间</el-checkbox
                                                        ><br />
                                                        <el-checkbox
                                                            label="创建人"
                                                            >创建人</el-checkbox
                                                        ><br />
                                                        <el-checkbox
                                                            label="操作"
                                                            >操作</el-checkbox
                                                        ><br />
                                                    </el-checkbox-group>
                                                </template>
                                            </el-dropdown-item>
                                        </el-dropdown-menu>
                                    </el-dropdown>
                                    <!-- </el-button> -->
                                </el-button-group>
                            </div>
                        </div>
                        <!--表单-->
                        <div class="addForm">
                            <el-table
                                ref="multipleTable"
                                :data="tableDate"
                                tooltip-effect="dark"
                                @selection-change="handleSelectionChange"
                                :header-cell-style="{
                                    background: '#e6e6e6',
                                    color: '#000',
                                }"
                                border
                            >
                                <el-table-column
                                    type="selection"
                                    width="50"
                                    align="center"
                                    @selection-change="handleSelectionChange"
                                >
                                </el-table-column>
                                <el-table-column
                                    type="index"
                                    width="70"
                                    label="序号"
                                    align="center"
                                    v-if="no1"
                                    show-overflow-tooltip
                                ></el-table-column>
                                <el-table-column
                                    prop="projectName"
                                    label="项目名称"
                                    align="center"
                                    v-if="no2"
                                    show-overflow-tooltip
                                >
                                </el-table-column>
                                <el-table-column
                                    prop="typeName"
                                    label="服务类型名称"
                                    align="center"
                                    v-if="no2"
                                    show-overflow-tooltip
                                >
                                </el-table-column>
                                <el-table-column
                                    prop="createDate"
                                    label="创建时间"
                                    align="center"
                                    show-overflow-tooltip
                                    v-if="no3"
                                >
                                </el-table-column>
                                <el-table-column
                                    prop="createPersonName"
                                    label="创建人"
                                    align="center"
                                    show-overflow-tooltip
                                    v-if="no4"
                                >
                                </el-table-column>
                                <el-table-column
                                    label="操作"
                                    align="center"
                                    width="250px"
                                    v-if="no7"
                                >
                                    <template slot-scope="scope">
                                        <el-tooltip
                                            class="item"
                                            effect="dark"
                                            content="查看"
                                            placement="top-start"
                                        >
                                            <button
                                                style="color: #000"
                                                class="iconfont icon-chakan tabBtn"
                                                @click="
                                                    handleClick(
                                                        '查看',
                                                        scope.row
                                                    )
                                                "
                                            ></button>
                                        </el-tooltip>
                                        <el-tooltip
                                            class="item"
                                            effect="dark"
                                            content="编辑"
                                            placement="top-start"
                                        >
                                            <button
                                                style="color: #000"
                                                class="iconfont icon-bianji3 tabBtn"
                                                @click="
                                                    handleClick(
                                                        '编辑',
                                                        scope.row
                                                    )
                                                "
                                            ></button>
                                        </el-tooltip>
                                        <el-tooltip
                                            class="item"
                                            effect="dark"
                                            content="删除"
                                            placement="top-start"
                                        >
                                            <button
                                                style="color: #000"
                                                class="iconfont icon-icon7 tabBtn"
                                                @click="deleteId(scope.row)"
                                            ></button>
                                        </el-tooltip>
                                    </template>
                                </el-table-column>
                            </el-table>
                            <!-- 分页 -->
                            <el-pagination
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :current-page="currentPage"
                                :page-sizes="[10, 20, 50, 100]"
                                :page-size="10"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="total"
                            ></el-pagination>
                        </div>
                    </el-tab-pane>
                </el-tabs>
            </div>
        </div>
        <!-- 新增功能模态框 -->
        <el-dialog
            :title="dialogTitle"
            :visible.sync="dialogVisible"
            width="990px"
            :before-close="handleClose"
            @close="dialogVisibleClone"
        >
            <el-form
                ref="addForm"
                :model="addForm"
                :rules="addFormRules"
                label-width="160px"
                :disabled="this.dialogTitle == '查看'"
            >
               <el-form-item label="项目名称：" prop="projectName">
                     <el-input placeholder="请输入项目名称" v-model='addForm.projectName'></el-input>
                </el-form-item>
                <el-form-item label="服务类型：" prop="typeName">
                    <el-radio-group v-model="addForm.typeName">
                        <el-radio label="上门走访、探望">上门走访、探望</el-radio>
                        <el-radio label="信息服务" >信息服务</el-radio>
                    </el-radio-group>
                     <div
                    class="fixed"
                    v-if="
                        this.addForm.typeName == '信息服务' &&
                        this.dialogTitle != '查看'
                    "
                    @click="handelAddProblem"
                >
                    <i class="el-icon-plus"></i>
                </div>
                </el-form-item>
                <div v-if="this.addForm.typeName == '上门走访、探望'">
                    <el-form-item>
                        <el-checkbox v-model="addForm.elderlyDemand" :checked="addForm.elderlyDemand==1? true:false" true-label="1" false-label="0">服务需求： （安全巡查 ，生活资料 , 文化娱乐 , 精神慰藉 , 其他服务）</el-checkbox>
                    </el-form-item>
                    <el-form-item>
                        <el-checkbox v-model="addForm.visitingRecord" :checked="addForm.visitingRecord==1? true:false" true-label="1" false-label="0">探视活动情况记录： （是否有探视活动情况记录）</el-checkbox>
                    </el-form-item>
                    <el-form-item>
                        <el-checkbox v-model="addForm.health" :checked="addForm.health==1? true:false" true-label="1" false-label="0">健康状况：(有 , 无)</el-checkbox>
                    </el-form-item>
                    <el-form-item>
                        <el-checkbox v-model="addForm.isUpImg" :checked="addForm.isUpImg==1? true:false" true-label="1" false-label="0">是否上传图片： （是 , 否）</el-checkbox>
                    </el-form-item> 
                    <el-form-item>
                        <el-checkbox v-model="addForm.satisfied" :checked="addForm.satisfied==1? true:false" true-label="1" false-label="0">被走访、探望满意度情况： (满意 , 不满意)</el-checkbox>
                    </el-form-item>
                </div>
                <div v-if="this.addForm.typeName == '信息服务'">
                    <div v-for="(item, index) in addProblemList" :key="index">
                        <el-form-item label="问题：">
                            <el-input
                                v-model="addProblemList[index].questionName"
                                placeholder="请输入问题"
                            ></el-input>
                        </el-form-item>
                    </div>
                </div>
               
            </el-form>
            <div slot="footer">
                <el-button type="primary" @click="save">确定</el-button>
                <el-button @click="dialogVisible = false">取消</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import request from "@/utils/request.js"
import AMap from "AMap" // 引入高德地图
import baseURL from "@/api/baseURL"
export default {
    data() {
        return {
            orgList: [],
            arrOrgList: [],
            orgLevels: "",
            // 图片预览
            dialogImageUrl: "",
            // 上传图片地址
            actionUrl:
                baseURL + "/jjyl/controller/uploadController/info/uploadPhoto",
            // 表单验证
            addFormRules: {
                projectName: [
                    {
                        required: true,
                        message: "请输入项目名称",
                        trigger: "blur",
                    },
                ],
                // 服务类型名称
                typeName: [
                    {
                        required: true,
                        message: "请输入服务类型名称",
                        trigger: "blur",
                    },
                ],
                // // 老人自理类别
                elderlyCategory: [
                    {
                        type: "string",
                        required: true,
                        message: "请至少选择一个自理类别",
                        trigger: "change",
                    },
                ],
                // 听力状况
                hearingStatus: [
                    {
                        required: true,
                        message: "请选择听力状况",
                        trigger: "change",
                    },
                ],
                // 病史
                medicalHistory: [
                    {
                        type: "array",
                        required: true,
                        message: "请至少选择一个病例",
                        trigger: "change",
                    },
                ],
                // 满意度
                satisfied: [
                    {
                        required: true,
                        message: "请填写满意度",
                        trigger: "blur",
                    },
                ],
            },
            selectedData: [],
            // 筛选数据功能按钮初始值
            checkList: ["序号", "项目名称","服务类型名称", "创建时间", "创建人", "操作"],

            // 健康状态勾选
            healthShow: false,
            // 图片上传勾选
            ImgShow: false,
            // 满意度勾选
            caseShow: false,

            // 表单测试数据
            tableDate: [],
            addForm: {
                typeName: "1", //服务类型名称
                elderlyDemand: 0, //老人服务需求
                visitingRecord: 0, //探视活动情况记录
                health: 0, //健康状况
                elderlyCategory: "", //老人自理类别
                isUpImg: 0, //是否上传图片
                // uploadImg: "", //上传地址
                satisfied: 0, //满意度
                reason: "", //原因
                feedback: "",
                replySelections: "",
                types: [],
                plySelections: "",
            },

            // 图片弹框
            dialogVisible1: false,
            // 查看弹框
            footShow: false,
            see: false,

            // 筛选按钮
            no1: true,
            no2: true,
            no3: true,
            no4: true,
            no5: true,
            no6: true,
            no7: true,

            // 搜素条件是否显示
            quanbu: true,

            currentPage: 1, //默认展示第一页
            total: 0, //总数据
            searchValue: true,
            showSlide: true,
            editableTabsValue: "1",
            tabIndex: 1,
            input: "",
            value: "",
            valueSq: "",
            multipleSelection: [],
            pageNo: 1,
            pageSize: 10,
            pageConfig: {
                pageSize: 10,
                total: 0,
                pageNo: 1,
            },
            // 搜索
            form: {
                typeName: "",
                pageNo: 1,
                pageSize: 10,
            },
            dialogVisible: false,
            dialogTitle: "",
            infoDialog: false,
            addProblemList: [
                {
                    questionName: "",
                    replySelection: "1",
                    reason: "",
                },
            ],
            AddDialogType: "",
            infoTitle: "",
        }
    },
    inject: ["reload"], //注入
    methods: {
        // 搜索条件
        showSearch() {
            this.searchValue = !this.searchValue
        },

        // 筛选功能按钮
        tableShow() {
            if (this.checkList.length > 0) {
                if (this.checkList.findIndex((obj) => obj == "序号") == -1) {
                    this.no1 = false
                } else {
                    this.no1 = true
                }
                if (
                    this.checkList.findIndex((obj) => obj == "服务类型名称") ==
                    -1
                ) {
                    this.no2 = false
                } else {
                    this.no2 = true
                }
                if (
                    this.checkList.findIndex((obj) => obj == "创建时间") == -1
                ) {
                    this.no3 = false
                } else {
                    this.no3 = true
                }
                if (this.checkList.findIndex((obj) => obj == "创建人") == -1) {
                    this.no4 = false
                } else {
                    this.no4 = true
                }
                if (this.checkList.findIndex((obj) => obj == "操作") == -1) {
                    this.no7 = false
                } else {
                    this.no7 = true
                }
            }
        },

        //信息服务弹窗
        setUpDialogClose() {
            // this.addForm.typeName = "" //类型名称
            // this.addForm.zfEvaluateContentList = []
            // this.AddDialogRow = [] //评价内容当前行内容
            this.addProblemList = [
                questionName= "",
                replySelection= 0,
                reason= "",
            ] //问题集合清空
        },

        // 添加问题
        handelAddProblem() {
            console.log(this.addProblemList)

            this.addProblemList.unshift({
                questionName: "",
                replySelection: 0,
                reason: "",
            })
        },
        deleteId(date) {
            this.$confirm("确认永久删除吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                let params = {
                    id: date.id,
                }
                params = Object.assign({}, params)
                request({
                    url: "/jjyl/admin/zfevaluateType/info/deleteById",
                    method: "POST",
                    data: params,
                }).then((res) => {
                    if (res.code == 200) {
                        this.showlist()
                        this.$message({
                            type: "success",
                            message: "删除成功!",
                        })
                    } else if (res.code == 201) {
                        this.showlist()
                        this.$message({
                            type: "error",
                            message: "该服务类型存在走访清单管理,无法删除!",
                        })
                    }
                })
            })
        },

        // 健康状况勾选
        checkHealth(val) {
            if (val == 0) {
                this.healthShow = true
            } else {
                this.healthShow = false
            }
        },

        // 图片上传勾选
        checkImg(val) {
            if (val == 0) {
                this.ImgShow = true
            } else {
                this.ImgShow = false
            }
        },

        // 满意度勾选
        checkSatis(val) {
            if (val == 1) {
                this.caseShow = true
            } else {
                this.caseShow = false
            }
        },

        // 弹框关闭
        handleClose() {
            this.dialogVisible = false
        },

        batchDelete() {
                var that = this
                var val = this.selectedData
                if (val.length > 0) {
                    this.$confirm("确认永久删除吗?", "提示", {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                        .then(() => {
                            val.forEach(function (item, index) {
                                request({
                                    url:
                                        "/jjyl/admin/zfevaluateType/info/deleteById",
                                    method: "POST",
                                    data: { id: item.id },
                                })
                            })
                        })
                        .then(() => {
                            this.$message({
                                type: "success",
                                message: "删除成功!",
                            })
                            this.showlist()
                        })
                } else {
                    this.$confirm("请选择要删除的项。", "提示")
                }
                this.$refs.multipleTable.clearSelection()
        },
        // 查询
        async query() {
            let params = {
                pageNo: this.pageNo,
                pageSize: this.pageSize,
                ...this.form,
            }
            params = Object.assign({}, params)
            await request({
                url: "/jjyl/admin/zfevaluateType/info/findList",
                method: "POST",
                data: params,
            }).then((res) => {
                console.log(res)
                if (res.content != null) {
                    this.tableDate = res.content.list
                    this.total = res.content.count
                } else {
                    this.tableDate = []
                }
            })
        },
        // 保存
        save() {
                this.$refs.addForm.validate((valid) => {
                    if (valid) {
                        if (this.dialogTitle == "新增") {
                            let zfEvaluateContentList=[]
                          if (this.addForm.typeName == "上门走访、探望") {
                                 zfEvaluateContentList = [
                                    {
                                    elderlyDemand:this.addForm.elderlyDemand,
                                        visitingRecord:this.addForm.visitingRecord,
                                        health:this.addForm.health,
                                        satisfied:this.addForm.satisfied,
                                        reason:this.addForm.reason,
                                        feedback:this.addForm.feedback,
                                        isUpImg:this.addForm.isUpImg
                                    }
                                ]
                          }else if(this.addForm.typeName == "信息服务"){
                                zfEvaluateContentList=this.addProblemList
                          }
                           
                            let params = {
                                pageNo: this.pageNo,
                                pageSize: this.pageSize,
                                ...this.addForm,
                                createPersonName: this.$store.state.info.name,
                               // zfEvaluateContentList:this.addForm.addProblemList,
                               zfEvaluateContentList:zfEvaluateContentList,
                                qujiId: JSON.parse( localStorage.getItem("czUserInfo")).qujiId,
                                shengjiId: JSON.parse(localStorage.getItem("czUserInfo")).shengjiId,
                                shijiId: JSON.parse(localStorage.getItem("czUserInfo")).shijiId,
                                stationId: JSON.parse( localStorage.getItem("czUserInfo")).stationId,
                                shequjiId: JSON.parse(localStorage.getItem("czUserInfo")).shequjiId,
                            }
                            params = Object.assign({}, params)
                            request({
                                url: "/jjyl/admin/zfevaluateType/info/insert",
                                method: "POST",
                                data: params,
                            }).then((res) => {
                                // console.log(res);
                                if (res.code == 200) {
                                    this.dialogVisible = false
                                    this.showlist()
                                }
                            })
                        }else if (this.dialogTitle == "编辑") {
                            if (this.addForm.typeName == "上门走访、探望") {
                                let zfEvaluateContentList = [
                                    {
                                        elderlyCategory: this.addForm.elderlyCategory.toString(),
                                       elderlyDemand:this.addForm.elderlyDemand,
                                        medicalHistory:this.addForm.medicalHistory.toString(),
                                        visitingRecord:this.addForm.visitingRecord,
                                        health:this.addForm.health,
                                        satisfied:this.addForm.satisfied,
                                        reason:this.addForm.reason,
                                        feedback:this.addForm.feedback,
                                        isUpImg:this.addForm.isUpImg
                                    }
                                ]
                                let list = {
                                    pageNo: this.pageNo,
                                    pageSize: this.pageSize,
                                    ...this.addForm,
                                    createPersonName: this.$store.state.info.name,
                                    elderlyCategory: this.addForm.elderlyCategory.toString(),
                                   // elderlyDemand: this.addForm.elderlyDemand.toString(),
                                    medicalHistory: this.addForm.medicalHistory.toString(),
                                }
                                // evaluateContentList.push(list)
                                let params = {
                                    typeName: this.addForm.typeName,
                                    id: this.addForm.id,
                                    projectName:this.addForm.projectName,
                                    // evaluateContentList: evaluateContentList,
                                    zfEvaluateContentList:zfEvaluateContentList
                                }
                                params = Object.assign({}, params)
                                request({
                                    url: "/jjyl/admin/zfevaluateType/info/update",
                                    method: "POST",
                                    data: params,
                                }).then((res) => {
                                    console.log(res)
                                    if (res.code == 200) {
                                        this.dialogVisible = false
                                        this.showlist()
                                    }
                                })
                            }
                            if (this.addForm.typeName == "信息服务") {
                                let params = {
                                    typeName: this.addForm.typeName,
                                    id: this.addForm.id,
                                    zfEvaluateContentList: this.addProblemList,
                                }
                                params = Object.assign({}, params)
                                request({
                                    url: "/jjyl/admin/zfevaluateType/info/update",
                                    method: "POST",
                                    data: params,
                                }).then((res) => {
                                    console.log(res)
                                    if (res.code == 200) {
                                        this.infoDialog = false
                                        this.dialogVisible = false
                                        this.showlist()
                                    }
                                })
                            }
                        }
                    }
                })
        },

        // 弹窗
        handleClick(type,date) {
            this.dialogVisible = true
            this.dialogTitle = type
            this.addForm= {
                typeName: "", //服务类型名称
                projectName:'',
                elderlyDemand: 0, //老人服务需求
                visitingRecord: 0, //探视活动情况记录
                health: 0, //健康状况
                elderlyCategory: 0, //老人自理类别
                isUpImg: 0, //是否上传图片
                // uploadImg: "", //上传地址
                satisfied:0, //满意度
                reason: "", //原因
                feedback: "",
            }
            this.addProblemList = [{
                questionName: "",
                replySelection: 0,
                reason: "",
            }]
            switch (type) {
                case "新增":
                    break
                case "编辑":
                    this.look(date)
                    break
                case "查看":
                    this.look(date)
                    break
            }
        },
        // end

        // 图片上传 start
        handleAvatarSuccess(res) {
            this.imageUrl = res.content
            this.addForm.img = res.content
        },
        beforeAvatarUpload(file) {
            const isJPG =
                file.type === "image/jpeg" || file.type === "image/png"
            const isLt2M = file.size / 1024 / 1024 < 2
            if (!isJPG) {
                this.$message.error("上传头像图片只能是 JPG 格式!")
                return
            }
            if (!isLt2M) {
                this.$message.error("上传头像图片大小不能超过 2MB!")
                return
            }
        },
        handlePicturePreview(file) {
            this.dialogVisible1 = true
            this.dialogImageUrl = file.url
        },
        // 图片上传 end

      
        handleSelectionChange(rows) {
            this.multipleSelection = rows
        },

        handleSelectionChange(data) {
            this.selectedData = data
        },

        // 表格
        showlist(s) {
            let params = {
                pageNo: this.pageNo,
                pageSize: this.pageSize,
                typeName:s === true ? '' :   this.form.typeName,
            }
            params = Object.assign({}, params)
            request({
                url: "/jjyl/admin/zfevaluateType/info/findList",
                method: "POST",
                data: params,
            }).then((res) => {
                // console.log(res);
                if (res.content != null) {
                    this.tableDate = res.content.list
                    this.total = res.content.count
                } else {
                    this.tableDate = []
                }
            })
        },

        // 查看
        look(date) {
            console.log(date)
            let params = {
                pageNo: this.pageNo,
                pageSize:
                this.pageSize,
                id: date.id,
            }
            params = Object.assign({}, params)
            request({
                url: "/jjyl/admin/zfevaluateType/info/getById",
                method: "POST",
                data: params,
            }).then((res) => {
                console.log(res)
                this.addForm.id = res.content.id
                this.addForm.typeName = res.content.typeName
                this.addForm.projectName = res.content.projectName
                if (date.typeName == "上门走访、探望") {
                    this.addForm.visitingRecord =
                        res.content.zfEvaluateContentList[0].visitingRecord
                    this.addForm.health =
                        res.content.zfEvaluateContentList[0].health
                    this.addForm.elderlyCategory =
                        res.content.zfEvaluateContentList[0].elderlyCategory
                    this.addForm.satisfied =
                        res.content.zfEvaluateContentList[0].satisfied
                    this.addForm.reason =
                        res.content.zfEvaluateContentList[0].reason
                    this.addForm.isUpImg =
                        res.content.zfEvaluateContentList[0].isUpImg
                    this.addForm.feedback =
                        res.content.zfEvaluateContentList[0].feedback
                     this.addForm.elderlyDemand =
                        res.content.zfEvaluateContentList[0].elderlyDemand
                    // if(res.content.zfEvaluateContentList[0].elderlyDemand!=null){
                    //     this.addForm.elderlyDemand =res.content.zfEvaluateContentList[0].elderlyDemand
                    // }else{
                    //     this.addForm.elderlyDemand = "";
                    // }
                    //this.addForm.elderlyDemand = res.content.zfEvaluateContentList[0].elderlyDemand == undefined ? [] : res.content.evaluateContentList[0].elderlyDemand.split( "," )
                    this.addForm.elderlyCategory =
                        res.content.zfEvaluateContentList[0].elderlyCategory ==
                        undefined
                            ? ""
                            : res.content.zfEvaluateContentList[0].elderlyCategory.split(
                                  ","
                              )
                    this.addForm.medicalHistory =
                        res.content.zfEvaluateContentList[0].medicalHistory ==
                        undefined
                            ? []
                            : res.content.zfEvaluateContentList[0].medicalHistory.split(
                                  ","
                              )
                }else if (date.typeName == "信息服务") {
                    this.addProblemList = res.content.zfEvaluateContentList
                        ? res.content.zfEvaluateContentList
                        : []
                }
                console.log(this.addProblemList)
            })
        },

        // 重置
        resert() {
            this.form = {}
            this.showlist()
        },
        dialogVisibleClone(){
            this.dialogVisible = false
            this.$refs.addForm.resetFields()
        },
        // 表单刷新
        resertTable() {
            this.showlist(true)
            this.checkList = [
                "序号",
                "项目名称",
                "服务类型名称",
                "创建时间",
                "创建人",
                "操作",
            ]
            this.tableShow()
            // this.form = {}
        },

        //每页请求数据
        handleSizeChange(val) {
            this.pageSize = val
            this.showlist()
            this.$message({
                message: `每页请求${val}条数据成功`,
                type: "success",
            })
        },
        //请求第几数据
        handleCurrentChange(val) {
            this.pageNo = val
            this.showlist()
            this.$message({
                message: `请求第${val}页数据成功`,
                type: "success",
            })
        },

        // 刷新页面
        Resert() {
            this.reload()
        },
        // 表单重置
        resetForm(formName) {
            if (this.$refs[formName] !== undefined) {
                this.$refs[formName].resetFields()
            }
        },
    },
    created() {
        this.showlist()
    },
}
</script>
<style lang="less" scoped>
/deep/.el-textarea{
    width:56%;
}
/deep/.el-checkbox{
   margin-right:10px;
}
.fixed {
    position: absolute;
    right: 53%;
    top: 43%;
    font-size: 20px;
}
/deep/ .el-dialog__body {
    padding: 30px 40px;
}
.rkld {
    display: flex;
    flex-direction: row;
    height: 100vh;
    overflow: hidden;
}

.rkldLeft {
    width: 234px;
    height: 100%;
    background: #37404f;
}

.rkldLeftLogo {
    background-color: rgb(55, 64, 79);
    height: 68px;
    width: 100%;
    display: flex;
    align-items: center;
    color: #ffffff;
}

.rkldLeftLogoImage {
    width: 39px;
    margin-left: 20px;
    margin-right: 10px;
}

.rkldRight {
    flex: 1;
    height: 100%;
    width: calc(100% - 266px);
    background-color: #ffffff;
}

.rkldRightHead {
    border-bottom: 1px solid #f5f5f5;
    width: 100%;
    background-color: #ececec;
    height: 69px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}

.mlIcon {
    height: 35px;
    width: 35px;
    font-size: 14px;
    margin-left: 15px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    border-radius: 3px;
}

.mlIcon:hover {
    background: rgba(0, 0, 0, 0.1);
}

::-webkit-scrollbar {
    display: none !important;
}

.rkldRightHeadRight {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-right: 15px;
}

.demo-form-inline {
    padding: 0 5%;
}

.btnform {
    text-align: center;
}

.bodymsg {
    width: 140px;
    height: 40px;
    background-color: #ffb404;
    color: #fff;
    text-align: center;
    line-height: 40px;
    border-radius: 2px;
    margin-top: 20px;
    cursor: pointer;
}

.switchpage {
    display: inline-block;
    margin-bottom: 10px;
}

.activesiwtch {
    background-color: #d6d7d8;
}

.rkldRightHeadRightLeft {
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 12px;
}

.rkldRightHeadRightLeft img {
    margin-right: 5px;
}

.rkldRightContent {
    height: calc(100% - 70px);
    overflow-y: auto;
    margin: 20px;
}

.searchTj {
     display: flex;
  flex-direction: column;
  position: relative;
  background: #F1F2F6;
  box-shadow:  0 0 6px rgba(151, 151, 151, .16);
  overflow: hidden;
  border-radius: 4px;
  margin:5px;
}

.searchTjHead {
    background: #fff;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    color: rgb(0, 0, 0);
    border-color: rgb(217, 217, 217);
    padding: 6px 15px;
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
}

.searchTjContent {
    padding: 15px 20px 0px 5px;
    border: 1px solid rgb(217, 217, 217);
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
}

.searchTjContentDiv {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-left: 40px;
    margin-bottom: 10px;
    border-radius: 4px;
}

.searchTjContentDivSpan {
    min-width: 58px;
    margin-right: 20px;
    font-size: 14px;
}

.searchTjContentDivInput {
    width: 20%;
    min-width: 196px;
}

/deep/ .arrowDown {
    width: 28px;
    height: 28px;
    background: #edf2f0;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    left: 50%;
    bottom: -14px;
    transform: translate(-50%, 0px) 2s;
    border-radius: 50%;
    z-index: 2;
    cursor: pointer;
    // transition: 2s;
}

/deep/ .el-tabs__content {
    padding-bottom: 20px;
}

.searchButtonDiv {
    height: 54px;
    display: flex;
    margin-top: 14px;
    align-items: center;
    justify-content: space-between;
}

.searchButtonDivLeft {
    display: flex;
}
/deep/ .el-button {
    border-radius: 4px;
    padding: 0px 8px !important;
    border: none;
    height: 30px;
}

.el-button-group /deep/ .el-button--warning:last-child {
    border-left-color: rgba(255, 255, 255, 0.5);
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
}

/deep/ .el-pagination {
    margin-top: 10px;
}

/deep/ .el-submenu__title i {
    color: #fff;
}

.el-submenu /deep/ .el-menu-item {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

/deep/ .el-submenu__title {
    border-bottom: 1px solid #2c3342;
    background: rgb(55, 64, 79) !important;
}

/deep/ .el-menu-item {
    border-bottom: 1px solid #2c3342;
    background: rgb(55, 64, 79) !important;
}

/deep/ .el-submenu.is-active /deep/ .el-submenu__title {
    border-bottom: 1px solid rgb(55, 64, 79);
}

/deep/
    .el-tabs--card
    > .el-tabs__header
    /deep/
    .el-tabs__item.is-active.is-closable {
    color: #0e2d5f;
}

/deep/ .el-menu .is-active {
    color: rgb(255, 255, 255) !important;
    background-color: #437ae1 !important;
}

/deep/ .el-submenu {
    width: 234px !important;
}

/deep/ .el-menu-item:hover {
    color: rgb(255, 255, 255) !important;
    background-color: #437ae1 !important;
}

/deep/ .tabBtn {
    margin: 0px;
}

.rkld .el-menu-vertical-demo:not {
    background: rgb(55, 64, 79) !important;
}

/* 用来设置当前页面element全局table 选中某行时的背景色*/
/deep/ .el-table__body tr.current-row > td {
    background-color: #fafad2 !important;
    color: #000;
}
/deep/ .el-table tbody tr:hover > td {
    background-color: #fafad2 !important;
}

.mapleft {
    margin-left: 10px;
    width: 200px;
    height: 400px;
    overflow-y: auto;
    border: 1px solid #dcdfe6;
    border-radius: 5px;
    p {
        line-height: 42px;
        text-align: center;
    }
}
// 弹框样式
/deep/ .el-dialog {
    .el-dialog__header {
        border-bottom: 1px solid #e6e6e6;
    }
    .el-dialog__footer {
        background: #e6e6e6;
    }
}
</style>
